<template>
  <section class="brieven-section" id="brieven">
    <div class="container">
      <div class="section-header">
        <span class="tag">{{ t('brieven.tag') }}</span>
        <h2 class="serif">{{ t('brieven.title') }}</h2>
        <p>{{ t('brieven.subtitle') }}</p>
      </div>

      <div class="brieven-list">
        <button
          v-for="tmpl in templates"
          :key="tmpl.key"
          class="template-card"
          type="button"
          @click="$emit('openTemplate', tmpl.key)"
        >
          <span class="template-kind" :class="tmpl.kindClass">{{ t(tmpl.kindKey) }}</span>
          <span class="template-title">{{ t(tmpl.titleKey) }}</span>
          <span class="template-desc">{{ t(tmpl.descKey) }}</span>
          <span class="template-cta">{{ t(tmpl.ctaKey) }}</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useLocale } from '../composables/useLocale'

const { t } = useLocale()

defineEmits(['openTemplate'])

const templates = [
  {
    key: 'brief-verlaging',
    kindClass: 'kind-brief',
    kindKey: 'brieven.template1.kind',
    titleKey: 'brieven.template1.title',
    descKey: 'brieven.template1.desc',
    ctaKey: 'brieven.template1.cta',
  },
  {
    key: 'bericht-verlaging',
    kindClass: 'kind-bericht',
    kindKey: 'brieven.template2.kind',
    titleKey: 'brieven.template2.title',
    descKey: 'brieven.template2.desc',
    ctaKey: 'brieven.template2.cta',
  }
]
</script>

<style scoped>
.brieven-section {
  padding: 80px 0;
  scroll-margin-top: 20px;
  background: var(--blue-dark);
  color: #fff;
}
@media (max-width: 768px) { .brieven-section { padding: 48px 0; } }
.section-header {
  text-align: center;
  max-width: 640px;
  margin: 0 auto 48px;
}
.section-header h2 { color: #fff; }
.section-header p { color: rgba(255, 255, 255, 0.7); }
.section-header .tag {
  display: inline-block;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  border-radius: 999px;
  padding: 8px 18px;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  margin-bottom: 20px;
}
.section-header h2 {
  font-size: clamp(40px, 6vw, 72px);
  font-weight: 800;
  line-height: 0.98;
  letter-spacing: -0.03em;
  margin-bottom: 16px;
}
.section-header p {
  font-size: 18px;
  line-height: 1.55;
}

.brieven-list {
  max-width: 720px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
@media (max-width: 600px) {
  .brieven-list { grid-template-columns: 1fr; }
}

.template-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  padding: 28px 28px 24px;
  background: var(--bg-card);
  border: 2px solid var(--line-soft);
  border-radius: 20px;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
}
.template-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.25);
  border-color: var(--yellow);
}

.template-kind {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 5px 12px;
  border-radius: 999px;
}
.kind-brief {
  background: var(--blue-pale);
  color: var(--blue-dark);
}
.kind-bericht {
  background: var(--yellow);
  color: var(--ink);
}

.template-title {
  font-family: 'Fraunces', serif;
  font-weight: 800;
  font-size: 20px;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--ink);
}
.template-desc {
  font-size: 14px;
  color: var(--ink-soft);
  line-height: 1.5;
}
.template-cta {
  font-size: 14px;
  font-weight: 700;
  color: var(--blue);
  margin-top: auto;
  transition: transform 0.2s;
}
.template-card:hover .template-cta {
  transform: translateX(4px);
}
</style>
